const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((module) => {
      // Guard: stale cached pages may cause the dynamic import to resolve with
      // an undefined/empty module namespace instead of rejecting outright.
      // Destructuring undefined would throw a TypeError that propagates to
      // Sentry, so we check first.  Web vitals reporting is non-critical.
      if (!module) return;
      const { onCLS, onFCP, onINP, onLCP, onTTFB } = module;
      onCLS(onPerfEntry);
      onFCP(onPerfEntry);
      onINP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    }).catch(() => {
      // Swallow import failures (e.g. network error, stale chunk 404 after
      // a new deploy).  Web vitals are non-critical and should never surface
      // as unhandled rejections.
    });
  }
};

export default reportWebVitals;
